/** JS string literal that is also safe inside an inline <script> (no "</script>" break-out). */
function scriptLiteral(value: string): string {
  return JSON.stringify(value).replace(/</g, "\\u003c");
}

/** Host-page snippet for an embed (GA/GTM style async loader with a command queue). */
export function buildEmbedSnippet(loaderUrl: string, publicKey: string): string {
  const src = scriptLiteral(loaderUrl);
  const key = scriptLiteral(publicKey);
  return [
    "<!-- Report AI Chat -->",
    "<script>",
    "(function(w,d,s,k){w.GARChat=w.GARChat||function(){(w.GARChat.q=w.GARChat.q||[]).push(arguments)};",
    "var j=d.createElement(s);j.async=1;j.src=" + src + ";j.dataset.key=k;d.head.appendChild(j)",
    "})(window,document,'script'," + key + ");",
    "</script>",
  ].join("\n");
}

/** CSP directives the host page needs if it sends a Content-Security-Policy. */
export function buildHostCspHint(appOrigin: string): string {
  return `script-src ${appOrigin}; connect-src ${appOrigin}; frame-src ${appOrigin};`;
}

/** One origin per line (or comma separated) → trimmed, de-duplicated list. */
export function parseOriginList(text: string): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const part of text.split(/[\n,]+/)) {
    const value = part.trim();
    if (value && !seen.has(value)) {
      seen.add(value);
      result.push(value);
    }
  }
  return result;
}
